import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["image", "loading", "placeholder", "alt"],
    _excluded2 = ["image", "loading", "placeholder", "alt"];
import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import './styles.scss';
export function Img(_ref) {
  var image = _ref.image,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? 'lazy' : _ref$loading,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? 'blurred' : _ref$placeholder,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? '' : _ref$alt,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  if (!image) return null;
  return /*#__PURE__*/React.createElement(GatsbyImage, Object.assign({
    placeholder: placeholder
  }, props, {
    image: getImage(image),
    alt: alt,
    loading: loading
  }));
}
export function BackgroundImage(_ref2) {
  var image = _ref2.image,
      _ref2$loading = _ref2.loading,
      loading = _ref2$loading === void 0 ? 'lazy' : _ref2$loading,
      _ref2$placeholder = _ref2.placeholder,
      placeholder = _ref2$placeholder === void 0 ? 'blurred' : _ref2$placeholder,
      _ref2$alt = _ref2.alt,
      alt = _ref2$alt === void 0 ? '' : _ref2$alt,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2);

  if (!image) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "mxm-bg-img-container"
  }, /*#__PURE__*/React.createElement(GatsbyImage, Object.assign({
    role: "presentation",
    alt: alt,
    placeholder: placeholder
  }, props, {
    image: getImage(image),
    loading: loading
  })));
}